import { cn } from '@/lib/utils'

interface SectionLabelProps {
  /** Two-digit index, e.g. "01". */
  index: string
  /** Short uppercase label, e.g. "FRAGMENTATION". */
  label: string
  className?: string
}

/**
 * "// 01 · LABEL" — mirrors the section-marker pattern used inside the
 * Android app (`// LOCK-IN`, `// FIELD`, `// ROSTER`) so the web reads as
 * the same product.
 */
export function SectionLabel({ index, label, className }: SectionLabelProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 font-display text-xs tracking-[0.2em] uppercase',
        className,
      )}
    >
      <span className="text-primary font-bold">//</span>
      <span className="tabular-nums text-primary/70">{index}</span>
      <span className="text-fg-subtle">·</span>
      <span className="text-primary">{label}</span>
    </div>
  )
}
